<template>
<div class="workSection row sm-block">
  <div class="worksectionLeft col-6 col-sm-12">
  <div class="">
    <div class="overlay"><h1><router-link :to="{name:'Projets'}" >Mon Travail</router-link></h1></div>
    <div class="overlay"><h3><router-link :to="{name:'Projets'}" >Découvrir <i class="fas fa-arrow-right"></i></router-link></h3></div>
  </div>

  </div>
  <div class="worksectionRight col-6 col-sm-12">
    <div class="overlay"><div class="workSectionIllustration">
      <svg width="0" height="0">
          <defs>
              <clipPath id="mask1" clipPathUnits="objectBoundingBox">
                  <path id="curve"
                        transform="scale(0.00150, 0.00150)"
                        d="M209.83 133.65C318.6 112.75 529.79 2 594.62 175.34C659.44 348.68 674.1 513.74 506.8 551.38C339.5 589.01 326.96 497.16 209.85 497.16C92.74 497.16 55.07 532.55 9.08 392.57C-36.92 252.6 101.07 154.55 209.83 133.65Z">
                        <animate attributeName="d" values="M209.83 133.65C318.6 112.75 529.79 2 594.62 175.34C659.44 348.68 674.1 513.74 506.8 551.38C339.5 589.01 326.96 497.16 209.85 497.16C92.74 497.16 55.07 532.55 9.08 392.57C-36.92 252.6 101.07 154.55 209.83 133.65Z;M190.67 99.58C299.43 78.68 543.98 73.69 608.81 247.03C673.64 420.37 622.29 404.43 454.99 442.06C287.69 479.7 337.61 561.04 220.5 561.04C103.39 561.04 55.07 532.55 9.08 392.57C-36.92 252.6 81.9 120.48 190.67 99.58Z;M209.83 133.65C318.6 112.75 529.79 2 594.62 175.34C659.44 348.68 674.1 513.74 506.8 551.38C339.5 589.01 326.96 497.16 209.85 497.16C92.74 497.16 55.07 532.55 9.08 392.57 C-36.92 252.6 101.07 154.55 209.83 133.65Z;" dur="5s" repeatCount="indefinite" /> </path>
              </clipPath>
          </defs>
      </svg>

  <router-link :to="{name:'Projets'}" ><img class="clip-svg" :src="`${publicPath}Cries-and-Whisper.jpg`" alt="logo accueil"></router-link>

</div></div>
    </div>

</div>
</template>

<script>
export default {
  data : function () {
    return{
      publicPath: process.env.BASE_URL
    }
  }
}
</script>


<style scoped>

h1 a{
  color: #222;
  font-size: 8rem;
    font-weight: bold;
      transition: 0.3s;
}

h1 a:hover{
  transition: 0.3s;
      color: #888;
}

h3{
  color: #222
}

.workSection{
  min-height: 100vh;

}

.worksectionLeft{
  min-height: 100vh;
  padding-left:7.5rem;
  display: flex;
  align-items:center;
  background-image: url('../assets/portrait-pattern.png');
  background-size: contain;
  background-position:  left;
  background-repeat: no-repeat;
  z-index: 1000;
}

.worksectionRight{
  min-height: 100vh;

}

.workSectionIllustration{
    min-height: 100vh;
  background-image: url('../assets/shape.svg');
  background-size: contain;
  background-repeat: no-repeat;
    background-position:  center;
    align-items: center;
    display: flex;
}

.clip-svg {
  width: 100%;
  -webkit-clip-path: url(#mask1);
clip-path: url(#mask1);

}

@media all and (max-width: 736px) {

  .sm-block{
    display: block;
  }

  .workSection{
            min-height: 0;
  }

  .worksectionLeft{
    z-index: 1000;
    background-image: none;
            min-height: 0;
            padding-top: 6.25rem;
  }

  .worksectionRight{

        z-index: -1000;
        min-height: 0;
  }

  .workSectionIllustration{
            z-index: -1000;
            align-items:flex-start;
            display: flex;
            margin-top: -15%;
            min-height: 0;
  }

}


</style>
